import http from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
// @ts-expect-error untyped dependency
import { getFormRoutingKey } from 'FormsUI/earlyRequest/earlyRequestsShared';
import { UPDATE_VALIDATION_ERROR } from 'FormsUI/constants/Routing';
export const ROUTING_ENDPOINT = 'forms-routing/v1/route/draft';
export const fetchRouting = ({
  formGuid
}) => http.get(`${ROUTING_ENDPOINT}/${formGuid}`);
export const getRouting = ({
  formGuid
}) => getFromEarlyRequest(getFormRoutingKey(formGuid), () => fetchRouting({
  formGuid
}));
export const upsertRouting = ({
  formRouting
}) => http.post(ROUTING_ENDPOINT, {
  data: formRouting
});
export const getSubCategoriesFromError = error => {
  if (error.errors) {
    return error.errors.map(err => UPDATE_VALIDATION_ERROR[err.subCategory]);
  }
  if (error.subCategory) {
    return [UPDATE_VALIDATION_ERROR[error.subCategory]];
  }
  return [];
};